import { v4 as uuidv4 } from 'uuid';

import { getCardPayments } from 'reducers/Payments';
import { markForProcessing } from 'actions/Payments';
import { openTerminalIntegration } from 'actions/integrations/terminal';
import { addSuccess } from 'actions/Error';
import { getClientCode } from 'reducers/Login';
import { withWaitingForTerminal } from 'paymentIntegrations';

import * as chase from './requests/chaseRequests';

export const title = 'Chase Terminal Interface';

export const initPayments = params => async (dispatch, getState) => {
  const {
    enableButtons,
    cardPayments,
    isCurrentSaleAReturn,
    resolvePayments,
    updateMessage,
    beforeDocSave,
    beforeDocDelete,
    formatCurrency,
  } = params;
  const clientCode = getClientCode(getState());
  const buttonsOnStart = ['console'];
  enableButtons(buttonsOnStart);

  const processPayments = async () => {
    let errors = false;
    let persistMessage = false;

    const makeRequest = payment => {
      if (payment.paid && payment.shouldProcess) {
        updateMessage(
          `Please void transaction #${
            payment.attributes.refNo
          } of ${formatCurrency(payment.amount)}`,
        );
        return chase.requestVoid();
      }
      if (isCurrentSaleAReturn) {
        const amount = payment.amount.replace(/-/g, '');
        updateMessage(`Processing refund of ${formatCurrency(amount)}...`);
        return chase.requestReturn({ amount, requestID: uuidv4(), clientCode });
      }
      updateMessage(
        `Processing payment of ${formatCurrency(payment.amount)}...`,
      );
      return chase.requestSale({
        ...payment,
        clientCode,
        requestID: uuidv4(),
      });
    };

    const processPayment = async (p, r) => {
      const success = r.transactionStatus.indexOf('Approved') >= 0;
      if (r.transactionType === 'Void' && success) {
        updateMessage(`Void successful!`);
        beforeDocDelete(p.key);
      } else if (
        success &&
        r.approvedAmount &&
        Number(r.approvedAmount) !== 0
      ) {
        addSuccess(
          `Transaction of ${formatCurrency(
            Number(r.approvedAmount),
          )} successful!`,
          { selfDismiss: true },
        );
        await beforeDocSave({
          key: p.key,
          type: 'CARD',
          amount:
            Number(p.amount) < 0 ? `-${r.approvedAmount}` : r.approvedAmount,
          cardType: r.paymentType,
          cardNumber: r.cardNumber,
          paid: true,
          attributes: {
            authCode: r.authCode,
            refNo: r.referenceNumber,
            CreditOrDebit: r.cardType,
            expirationDate: '', // is this needed/legal?
          },
        });
      } else {
        errors = true;
        console.error('Failed to process payment with chase', r);
        updateMessage(`Error: ${r.transactionStatus} | ${r.hostResponseText}`);
      }
    };

    await cardPayments.reduce(
      (pr, p) =>
        pr.then(acc =>
          dispatch(
            withWaitingForTerminal(async () => {
              try {
                const res = await makeRequest(p);
                if (res.data) {
                  const [record] = res.data.records;
                  await processPayment(p, record);
                } else if (res instanceof Error) {
                  errors = true;
                  persistMessage = true;
                  updateMessage(res.message);
                  return [[], []];
                }
                return [...acc, res];
              } catch (err) {
                return [...acc, err];
              }
            }),
          ),
        ),
      Promise.resolve([]),
    );

    if (errors) {
      enableButtons([...buttonsOnStart, 'return-back']);
      if (!persistMessage)
        updateMessage('Something went wrong, please try again...');
    } else {
      resolvePayments();
    }
  };
  processPayments();
};

export const voidPayments = params => async (dispatch, getState) => {
  const cardPayments = getCardPayments(getState()).filter(
    payment => payment.paid && !payment.shouldProcess,
  );
  cardPayments.forEach(p => dispatch(markForProcessing({ key: p.key })));
  const paymentsToProcess = getCardPayments(getState()).filter(
    payment => payment.paid && payment.shouldProcess,
  );
  if (paymentsToProcess.length) {
    await dispatch(openTerminalIntegration(params));
    // // Voids are not possible at the moment
    // dispatch(
    //   addSuccess('All payments voided successfully', { selfDismiss: true }),
    // );
  }
};

export const chaseConsolePayments = params => async () => {
  // Used in button explicitly for logging to console
  // eslint-disable-next-line no-console
  console.log('chase payments', params.cardPayments);
};

export const closeBatch = () => async () => {
  return chase.requestCloseBatch().then(r => {
    if (r.data) {
      const { resultCode } = r.data.records[0];
      if (resultCode === '0') {
        return true;
      }
      return false;
    }
    return false;
  });
};

export const returnBack = params => async () => params.rejectPayments();

export const functions = [
  {
    actionOnClick: chaseConsolePayments,
    text: 'Console payments',
    name: 'console',
    variant: 'light',
  },
  {
    actionOnClick: returnBack,
    text: 'Return back',
    name: 'return-back',
    variant: 'warning',
  },
];
